import dynamic from 'next/dynamic';
import { BlockProps } from '../BlockProps';
import { IDashboardBlockData } from './IDashboardBlockData';

export const DynamicDashboardBlock = dynamic<BlockProps<IDashboardBlockData>>(
    () => import('./DashboardBlock').then(md => md.DashboardBlock),
);
